<template>
  <div>
    <b-row>
      <b-col
        md="7"
        lg="5"
        class="mt-5 mx-auto"
        data-aos="fade-left"
        v-if="success"
      >
        <b-form @submit.prevent="onSubmit" id="set-password">
          <div class="content">
            <h4>Hola !</h4>
            <p>Configura tu nueva contraseña</p>
          </div>
          <b-form-group :class="{ formLoading: isLoading }">
            <md-field>
              <label>Contraseña</label>
              <md-input
                type="password"
                name="password"
                v-model="form.password"
                placeholder="Contraseña"
                required
              />
            </md-field>
            <md-field>
              <label>Repite tu Contraseña</label>
              <md-input
                type="password"
                name="password"
                v-model="form.secondpassword"
                placeholder="Repite tu Contraseña"
                required
              />
            </md-field>
            <md-button type="submit" class="md-raised md-primary">Configurar</md-button>
          </b-form-group>
          <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
          </div>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Auth from "@/services/Auth";

export default {
  data: () => ({
    form: {
      email: "",
      password: "",
      secondpassword: "",
    },
    success: true,
    labels: "",
    isLoading: false,
    error: false,
  }),
  methods: {
    onSubmit() {
      this.isLoading = true;
      if(this.form.password !== this.form.secondpassword || this.form.password.length < 12 || this.form.secondpassword.length < 12){
          this.$toast.error("Las contraseñas no coinciden o no cumplen con el tamaño minimo (12 caracteres)")
          this.isLoading = false
      }else{
      Auth.setPassword(this.form)
        .then(() => {
          this.error = false;
          this.isLoading = false;
          this.$toast.success("Configuración Exitosa, Ahora puedes iniciar sesión")
          this.$router.push({ name: "login" });
             
        })
        .catch(() => {
          this.error = true;
          this.isLoading = false;
          this.$toast.error("Algo pasó, intentalo de nuevo")
        });
    }
    },
  },
  beforeCreate() {
    Auth.validate(this.$route.query.t)
      .then((data) => {
        const now = new Date();
        const exp = new Date(data.data.expiration);
        const diff = exp.getTime() - now.getTime();
        if (diff <= 0) {
          this.$router.push({ name: "login" });
        } else {
          this.form.email = data.data.email;
          this.success = true;
        }
      })
      .catch(() => {
        this.$router.push({ name: "login" });
      });
  },
  mounted() {
    
  },
};
</script>

<style src="../main.css"></style>
